import { Injectable } from "@angular/core"
import { CanActivate, CanActivateChild } from "@angular/router"

@Injectable({providedIn: 'root'})
export class ContentTypeGuard implements CanActivate, CanActivateChild {
  // TODO: don't allow routing to written content types if video and vice versa
  canActivate() {
    return true
  }
  canActivateChild() {
    return true
  }
}
